import { D as Divider, d as defineCustomElement$1 } from './p-0585e0e2.js';
const OwcDivider = Divider;
const defineCustomElement = defineCustomElement$1;
export { OwcDivider, defineCustomElement };